import queryString from "query-string";
import { GET_LIST, SAVE_DATA, REMOVE_DATA } from "../../api/site_mapping";

const state = {
  list: [],
  editData: {},
};

const mutations = {
  SET_LIST: (states, payload) => {
    states.list = payload;
  },
  SET_EDIT: (states, payload) => {
    payload = {
      ...payload,
      ...{ departments: payload.departments.split(",") },
    };
    states.editData = payload;
  },
};

const actions = {
  GET_LIST: async ({ commit }, query) => {
    query = queryString.stringify(query);
    const resp = await GET_LIST(query);
    const data = resp.data.data;
    commit("SET_LIST", data);
  },
  SAVE_DATA: ({}, payload) => {
    return SAVE_DATA(payload);
  },
  REMOVE_DATA: ({}, id) => {
    return REMOVE_DATA(id);
  },
};

const getters = {
  list: (states) => states.list,
  detail: (states) => states.detail,
  editData: (states) => states.editData,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
